import PosService from "../services/pos.service";
import GoodsService from "../services/goods.service";
import Vue from 'vue';
// import {TokenService} from "../services/storage.service";
const initialWholesalePosError = {
	boolean: false,
	message: ''
}
const initialState = {
	currentSuspendSale: {},
	isFromSaleDocPage: false,
	wholesalePosError: {
		boolean: false,
		message: ''
	},
	loadingForPosTable: false,
	priceChangedResponse: {success: false},
	fetchLoading: true,
	withDocumentStore: false,
	cartItems: [],
	lastAddedItem: null,
	totalCount: 0,
	totalSum: 0,
	currentSaleNumber: '',
	currentSaleSuspendNumber: '',
	lastSuspendedSaleNumber: '',
	currentSuspendId: null,
	currentSaleId: null,
	shopName: '',
	shopAddress: '',
	cashierFullName: '',
	currentSellerName: '',
	sellerId: null,
	shopId: null,
	discount: 0,
	errorOccur: false,
	convertError: false,
	items: [],
	searchLoading: false,
	dataIndex: 0,
	latestDrafts: [],
	latestSuspends: [],
	finishedSale: {},
	posDisabled: false,
	saleFinishError: false,
	saleFinishLoading: false,
	checkPage: false,
	saleItemForDiscountModal: {},
	customPromotion: null,
	client: {},
	finalTotalSum: 0,
	realTotalSum: 0,
	comment: '',
	isReturn: false,
	checkForWholeSale: {},
	saleForDocument: {
		saleItems: []
	},
	nakladnoyDocument: null,
	priceListItems:{},
	priceListItemsGET:{},
	priceListStatus: false,
	saleItemsForExcel: null
};

const state = () => ({...initialState});

const getters = {
	getSaleItemsForExcel:(state) => {
		return state.saleItemsForExcel
	} ,
	getItems: (state) => {
		let searchItems = JSON.stringify(state.items.slice());
		searchItems = JSON.parse(searchItems).map(el => {return el});
		const lookup = searchItems.reduce((a, e) => {
			a[e.id] = ++a[e.id] || 0;
			return a;
		  }, {});

		// let length = searchItems.length;
		let equalItems = searchItems.filter(e => lookup[e.id]);
		for (let i = 0; i < equalItems.length; i++) {
			searchItems.forEach(el => {
				if(el.id == equalItems[i].id) {
					Vue.set(el, "isPriceDifferent", true);
					if (!Array.isArray(el.incomeDates)) {
						Vue.set(el, "incomeDates", el.incomeDates.substring(1, el.incomeDates.length-1).split(",").map(String));
					}
				}
			})
		}
		return searchItems;
	},
	getCartItems: (state) => {
		return state.cartItems
	},
	getTotalWeight: (state) => {
		let tempWeight = 0;
		for (let i = 0; i < state.cartItems.length; i++) {
			tempWeight += state.cartItems[i].weight ? state.cartItems[i].weight * state.cartItems[i].count : 0;
		}
		return tempWeight;
	},
	getDraft: (state) => {
		return state.latestDrafts;
	},
	getCashierName: (state) => {
		return state.cashierFullName
	},
	getDiscountItemForModal: (state) => {
		return state.saleItemForDiscountModal;
	}
}


const actions = {
	/**
	 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
	 * QO'SHILDI BU ACTION('fetchWholesaleSearchItems') 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
	 */
	async fetchWholesaleSearchItems({ commit }, keyword) {
		try {
			commit("setSearchLoader", true);
			const response = await PosService.fetchWholesaleSearchItems(keyword);
			commit("setPosItems", response.data);
			commit("setSearchLoader", false);
			return true;
		} catch (e) {
			commit("setSearchLoader", false);
			return false;
		}
	},
	async setLatestPrices({commit}, payload) {
		try {
			const response = await PosService.setLatestPrices(payload);
			commit('setWholesalePosError', initialWholesalePosError)
			commit('setPriceChangedResponse', response.data)
			return true;
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setWholesalePosError', {message: response.message, boolean: true});
			commit('setPriceChangedResponse', null);
			return false
		}
	},
	async getPriceListItems({commit},object) {
		try {
			const response = await PosService.salePriceList(object);
			commit('setPriceListItems', response.data)
			commit('setPriceListStatus', true)
			return true;
		} catch (e) {
			return false
		}
	},
	async getPriceListItemsSale({commit},saleId) {
		try {
			const response = await PosService.salePriceListGet(saleId);
			commit('setPriceListItemsGET', response.data)
			commit('setPriceListStatus', true)
			return true;
		} catch (e) {
			return false
		}
	},


	async getLatestDrafts({commit}) {
		try {
			const response = await PosService.getDrafts();
			commit('setLatestDrafts', response.data)
			return true;
		} catch (e) {
			return false
		}
	},
	async getLatestSuspends({commit}) {
		try {
			const response = await PosService.getSuspendsForWholesale();
			commit('setLatestSuspends', response.data)
			return true;
		} catch (e) {
			return false
		}
	},
	async createPosDraft({commit}, emptyObject) {
		try {
			const response = await PosService.createSaleDraftService(emptyObject);
			commit('setDraft', response.data);
			commit('setErrorOccur', false);
			return true
		} catch (e) {
			await commit('setErrorOccur', true);
		}
	},

	async setErrorOccurNotHappen({commit}) {
		await commit('setErrorOccur', false);
	},

	async editDraft({commit, state}, sale) {
		try {
			sale.id = state.currentSaleId;
			const response = await PosService.editSaleDraft(sale);
			await commit('editDraftMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	// BU ACTION ISHLATILINMAYAPTI
	async editDraftOptom({commit, state}, sale) {
		try {
			sale.id = state.currentSaleId;
			const response = await PosService.editSaleDraftOptom(sale);
			await commit('editDraftOptomMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	// THIS IS FOR CONVERTING BOOKING DOC TO SALE AND EDIT TO CALCULATE VALUES PROPERLY
	async editBookingResponse({commit, state}, sale) {
		try {
			const response = await PosService.editWholesaleService(sale);
			await commit('editForBookingToSale', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async editWholesale({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.editWholesaleService(sale);
			await commit('editDraftWholesaleMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async convertCurrency({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.currencyConvertService(sale);
			await commit('setConvertError', false);
			await commit('editDraftWholesaleMutation', response.data);
			return true
		} catch (e) {
			await commit('setConvertError', false);
			return false
		}
	},
	async suspendSale({commit, state}, sale) {
		try {
			if (state.currentSuspendId != null) {
				sale.id = state.currentSuspendId;
			} else {
				sale.id = state.currentSaleId;
			}
			const response = await PosService.suspendSaleService(sale);
			await commit('setSuspendResponse', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async editForExcelSuspend({commit, state}, sale) {
		try {
			// sale.id = state.currentSaleId;
			state.fetchLoading = true
			const response = await PosService.editPosWholeSale(sale);
			if(response.data) {
				await commit('editForExcelSuspend', response.data);
				setTimeout(() => {
					state.fetchLoading = false
				},100)
			}else {
				commit('editForExcelSuspend', null);
			}
			return true
		} catch (e) {
			commit('editForExcelSuspend', null);
			return false
		}
	},
	async editForPosDraft({commit, state}, sale) {
		try {
			// sale.id = state.currentSaleId;
			commit('setPosTableLoading', true);
			const response = await PosService.editPosWholeSale(sale);
			commit('setPosTableLoading', false);
			commit('editForPosDraftMutation', response.data);
			return true
		} catch (e) {
			commit('setPosTableLoading', false);
			return false
		}
	},
	async getSaleById({commit}, saleId) {
		try {
			// sale.id = state.currentSaleId;
			const response = await PosService.getSaleWithId(saleId);
			commit('setSaleById', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	async deleteSuspendStore({commit}, itemId) {
		try {
			const response = await PosService.deleteSuspendSaleService(itemId);
			commit('deleteSuspendtMutation', response.data);
			return true
		} catch (e) {
			return false
		}
	},


	async getItemsForPos({commit}, keyword) {
		try {
			commit('setSearchLoader', true);
			const response = await GoodsService.fetchGoodsForWholesale(keyword);
			commit('setPosItems', response.data);
			commit('setSearchLoader', false);
			return true
		} catch (e) {
			commit('setSearchLoader', false);
			return false
		}
	},
	async getItemsForPosReturn({commit}, keyword) {
		try {
			commit('setSearchLoader', true);
			const response = await GoodsService.fetchGoodsForPos(keyword);
			commit('setPosItems', response.data);
			commit('setSearchLoader', false);
			return true
		} catch (e) {
			commit('setSearchLoader', false);
			return false
		}
	},

	async saleFinish({state, commit, dispatch}, payload) {
		try {
			commit('setSaleFinishLoading', true);
			if (state.currentSuspendId != null) {
				payload.id = state.currentSuspendId;
			} else {
				payload.id = state.currentSaleId;
			}
			const response = await PosService.finishSale(payload);
			await commit('setFinishedSale', response.data);
			commit('setSaleFinishLoading', false);
			// await commit('resetState');
			await commit('clients/resetCurrentClient', null, {root: true});
			await commit('clients/setMemberCardForSideBar', {}, {root: true});
			// await dispatch('createPosDraft', {});
			await dispatch('getLatestSuspends');
			return true
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('setSaleFinishError', {message: response.message, boolean: true});
			commit('setSaleFinishLoading', false);
			return false;
		}
	},

	async increaseCount({commit}, dataIndex) {
		await commit('increaseCountWithIndex', dataIndex);
		// commit('setPosToStorage');
	},
	async decreaseCount({commit}, dataIndex) {
		await commit('decreaseCountWithIndex', dataIndex);
		// commit('setPosToStorage');
	},
	setSusPendClient({commit}, client) {
		commit('setClientSuspend', client);
	},

	setSaleItemForDiscountModal({commit}, data) {
		commit('setSaleItemForDiscountModalMutation', data);
	},
	async setIncrementValue({commit}, payload) {
		await commit('setValue', payload);
	},
	async setItemWeightAction({commit}, payload) {
		await commit('setItemWeightMutation', payload);
	},

	async addToCartAction({commit}, item) {
		await commit('setCartItem', item);
		// commit('setPosToStorage');
	},
	async deleteFromCartAction({commit}, index) {
		await commit('deleteItemFromCart', index);
	},
	/*getPosFromStorage({commit}, posObj) {
		commit('setPosObjToState', posObj);
	}*/

	async setDefaultPriceListItems({commit},flag){
		await commit('setPriceListStatus', flag);
		await commit('setPriceListItems', []);
	}
};

const mutations = {
	/**
	 * SAVDONI FRONT ENDDA HISOB KITOBINI QILIB OXIRIDA BACK ENDGA YUBORADIGAN QILISH UCHUN
	 * QO'SHILDI BU MUTATION('editWholesaleLocally') 12.05.2020 (BAXTIYOR ADDED FROM GLOBAL_TASHKENT BRANCH)
	 */
	editWholesaleLocally(state, saleDoc) {
		state.cashierFullName = saleDoc.cashierFullName;
		/** IF ITEM IS NEW ADDED SET saleItemId TO IT **/
		if (state.lastAddedItem) {
			if (state.lastAddedItem.wrapped) {
				Vue.set(
					state.cartItems.find(
						el =>
							el.itemId == state.lastAddedItem.itemId &&
							el._rowVariant == state.lastAddedItem._rowVariant
					),
					"wrappedItems",
					saleDoc.saleItems.find(
						el =>
							el.itemId == state.lastAddedItem.itemId &&
							el._rowVariant == state.lastAddedItem._rowVariant
					).wrappedItems
				);
			}
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"saleItemId",
				saleDoc.saleItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				).saleItemId
			);
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"promotions",
				saleDoc.saleItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				).promotions
			);
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"discountPriceUzs",
				saleDoc.saleItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				).priceWholesale
			);
			Vue.set(
				state.cartItems.find(
					el =>
						el.itemId == state.lastAddedItem.itemId &&
						el._rowVariant == state.lastAddedItem._rowVariant
				),
				"customPromotion",
				{}
			);
			state.cartItems.find(
				el =>
					el.itemId == state.lastAddedItem.itemId &&
					el._rowVariant == state.lastAddedItem._rowVariant
			).id = saleDoc.saleItems.find(
				el =>
					el.itemId == state.lastAddedItem.itemId &&
					el._rowVariant == state.lastAddedItem._rowVariant
			).saleItemId;
		}
		state.lastAddedItem = null;
		saleDoc.saleItems.forEach(el => {
			Vue.set(
				state.cartItems.find(
					item =>
						item.itemId == el.itemId &&
						el.originalPriceWholesale == item.originalPriceWholesale
				),
				"customPromotion",
				el.customPromotion
			);
			Vue.set(
				state.cartItems.find(
					item =>
						item.itemId == el.itemId &&
						el.originalPriceWholesale == item.originalPriceWholesale
				),
				"discountPriceUzs",
				el.discountPriceUzs
			);
			Vue.set(
				state.cartItems.find(
					item =>
						item.itemId == el.itemId &&
						el.originalPriceWholesale == item.originalPriceWholesale
				),
				"priceWholesale",
				el.priceWholesale
			);
			Vue.set(
				state.cartItems.find(
					item =>
						item.itemId == el.itemId &&
						el.originalPriceWholesale == item.originalPriceWholesale
				),
				"promotions",
				el.promotions
			);
		});
		state.finalTotalSum = saleDoc.finalTotalSum;
		state.realTotalSum = saleDoc.realTotalSum;
		// if (saleDoc.customPromotion.discount >= 0) {
		// 	state.discount = saleDoc.customPromotion.discount;
		// } else {
		// 	state.discount = 0;
		// }
	},
	setIsFromSaleDocPage(state, boolean) {
		state.isFromSaleDocPage = boolean;
	},
	setWholesalePosError(state, payload) {
		state.wholesalePosError.message = payload.message;
		state.wholesalePosError.boolean = payload.boolean;
	},
	setPosTableLoading(state, payload){
		state.loadingForPosTable = payload;
	},
	setPriceChangedResponse(state, payload){
		state.priceChangedResponse = payload;
	},
	setPriceListStatus(state,payload){
		state.priceListStatus = payload;
	},
	setPriceListItems(state,payload){
		state.priceListItems = payload;
	},
	setPriceListItemsGET(state,payload){
		state.priceListItemsGET = payload;
	},
	setTotalPaid(state, checkObject) {
		state.checkForWholeSale = checkObject;
	},
	resetState(state) {
		state.comment = initialState.comment;
		state.cartItems = [];
		state.totalCount = initialState.totalCount;
		state.totalSum = initialState.totalSum;
		state.customPromotion = initialState.customPromotion;
		state.discount = initialState.discount;
		state.finalTotalSum = initialState.finalTotalSum;
		state.realTotalSum = initialState.realTotalSum;
		state.comment = initialState.comment;

	},
	setPosDisabled(state, boolean) {
		state.posDisabled = boolean;
	},
	setErrorOccur(state, payload) {
		state.errorOccur = payload
	},
	setConvertError(state, payload) {
		state.convertError = payload
	},
	setMemberCardForDiscount(state, memberCardDiscount) {
		state.discount = memberCardDiscount;
	},
	setClientSuspend(state, client) {
		state.client = client;
	},
	changeWithDocument(state, booleanValue) {
		state.withDocumentStore = booleanValue;
	},
	resetSuspendId(state) {
		state.currentSuspendId = null
		state.currentSuspendSale = {}
	},
	setSellerName(state, stringForName) {
		state.currentSellerName = stringForName;
	},
	setSellerId(state, sellerId) {
		state.sellerId = sellerId;
	},
	setSaleItemForDiscountModalMutation(state, data) {
		state.saleItemForDiscountModal = data;
	},
	setCustomPromotionForItem(state, payload) {
		Vue.set(state.cartItems[payload.index], "customPromotion", payload.obj);
		state.lastAddedItem = null;
	},
	setCustomPromotionGeneral(state, payload) {
		state.customPromotion = payload.obj;
	},

	deleteSuspendtMutation(state, response) {

	},

	setLatestDrafts(state, response) {
		state.latestDrafts = response;
	},
	setLatestSuspends(state, response) {
		state.latestSuspends = response;
	},
	editDraftWholesaleMutation(state, response) {
		state.cashierFullName = response.cashierFullName;
		// state.cartItems = response.saleItems ? response.saleItems : [];
		// state.cartItems.customPromotion = null;
		/** IF ITEM IS NEW ADDED SET saleItemId TO IT **/
		if (state.lastAddedItem) {
			if (state.lastAddedItem.wrapped) {
				Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "wrappedItems", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).wrappedItems);
			}
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "saleItemId", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).saleItemId);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "promotions", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).promotions);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "discountPriceUzs", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).discountPriceUzs);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "customPromotion", null);
			state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).id = response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).saleItemId;
		}
		state.lastAddedItem = null;
		response.saleItems.forEach(el => {
			Vue.set(state.cartItems.find(item => item.itemId == el.itemId &&  el.originalPriceWholesale == item.originalPriceWholesale), "customPromotion", el.customPromotion)
			Vue.set(state.cartItems.find(item => item.itemId == el.itemId &&  el.originalPriceWholesale == item.originalPriceWholesale), "discountPriceUzs", el.discountPriceUzs)
			Vue.set(state.cartItems.find(item => item.itemId == el.itemId &&  el.originalPriceWholesale == item.originalPriceWholesale), "priceWholesale", el.priceWholesale)
			Vue.set(state.cartItems.find(item => item.itemId == el.itemId &&  el.originalPriceWholesale == item.originalPriceWholesale), "promotions", el.promotions)
		});
		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		if (response.customPromotion.discount >= 0) {
			state.discount = response.customPromotion.discount;
		} else {
			state.discount = 0;
		}
	},
	// BU ISHLATILINMAYAPTI
	editDraftOptomMutation(state, response) {
		state.cashierFullName = response.cashierFullName;
		state.cartItems = response.saleItems ? response.saleItems : [];
		// state.cartItems.customPromotion = null;
		response.saleItems.forEach(el => {
			if (el.customPromotion) {
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "customPromotion", response.saleItems.find(item => item.itemId == el.itemId).customPromotion)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "discountPriceUzs", response.saleItems.find(item => item.itemId == el.itemId).discountPriceUzs)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId), "promotions", response.saleItems.find(item => item.itemId == el.itemId).promotions)
			}
		});

		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		if (response.customPromotion.discount >= 0) {
			state.discount = response.customPromotion.discount;
		} else {
			state.discount = 0;
		}
	},
		// BU ISHLATILINMAYAPTI
	editDraftMutation(state, response) {
		state.cashierFullName = response.cashierFullName;
		/** IF ITEM IS NEW ADDED SET saleItemId TO IT **/
		if (state.lastAddedItem) {
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "saleItemId", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).saleItemId);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "promotions", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).promotions);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "discountPriceUzs", response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).discountPriceUzs);
			Vue.set(state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant), "customPromotion", null);
			state.cartItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).id = response.saleItems.find(el => el.itemId == state.lastAddedItem.itemId && el._rowVariant == state.lastAddedItem._rowVariant).saleItemId;
		}
		response.saleItems.forEach(el => {
			if (el.customPromotion) {
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant), "customPromotion", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).customPromotion)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant), "discountPriceUzs", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).discountPriceUzs)
				Vue.set(state.cartItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant), "promotions", response.saleItems.find(item => item.itemId == el.itemId && item._rowVariant == el._rowVariant).promotions)
			}
		});
		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		// if (response.customPromotion.discount >= 0) {
		// 	state.discount = response.customPromotion.discount;
		// } else {
		// 	state.discount = 0;
		// }
	},
	setSuspendResponse(state, response) {
		state.lastSuspendedSaleNumber = response.saleNumber;
	},

	editForPosDraftMutation(state, response) {
		state.currentSuspendSale = response;
		state.cartItems = response.saleItems ? response.saleItems : [];
		state.totalCount = 0;
		for (let i = 0; i < response.saleItems.length; i++) {
			state.totalCount += response.saleItems[i].count;
		}
		state.totalSum = response.amountOfPaymentUzs;
		state.currentSaleSuspendNumber = response.saleNumber;
		state.currentSuspendId = response.id;
		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		state.comment = response.comment;
		if (response.customPromotion != undefined) {
			state.customPromotion = response.customPromotion;
		} else {
			state.customPromotion = null;
		}
		// state.totalCount = response.saleItems[0].count;

	},
	// THIS IS FOR CONVERTING BOOKING DOC TO SALE
	editForBookingToSale(state, response) {
		state.cartItems = response.saleItems ? response.saleItems : [];
		state.totalCount = 0;
		for (let i = 0; i < response.saleItems.length; i++) {
			state.totalCount += response.saleItems[i].count;
			if (response.saleItems[i].weight) {
				Vue.set(state.cartItems[i], "weight", response.saleItems[i].weight);
			} else {
				Vue.set(state.cartItems[i], "weight", 0);
			}
		}
		state.totalSum = response.amountOfPaymentUzs;
		state.finalTotalSum = response.finalTotalSum;
		state.realTotalSum = response.realTotalSum;
		state.comment = response.comment;
		if (response.customPromotion != undefined) {
			state.customPromotion = response.customPromotion;
		} else {
			state.customPromotion = null;
		}
	},
	editForExcelSuspend(state, sale) {
		if(sale) {
			state.saleItemsForExcel = sale.saleItems
		}
	},
	setSaleById(state, sale) {
		state.saleForDocument = sale;
	},
	setFinishedSale(state, response) {
		state.finishedSale = response;
		state.saleFinishError = false;
	},
	setSaleFinishError(state, obj) {
		state.saleFinishError = obj.message;
		state.finishedSale = {};
	},
	setSaleFinishLoading(state, boolean) {
		state.saleFinishLoading = boolean;
	},
	/*setPosToStorage(state) {
		let temp = {
			cartItems: state.cartItems,
			totalCount: state.totalCount,
			totalSum: state.totalSum
		}
		TokenService.setPos(JSON.stringify(temp));
	},*/

	setDraft(state, response) {
		state.currentSaleNumber = response.saleNumber;
		state.currentSaleId = response.id;
		state.shopName = response.shopName;
		state.shopAddress = response.shopAddress;
		state.shopId = response.shopId;
		state.cashierFullName = response.cashierFullName;
		state.currentSuspendId = null;
		state.currentSuspendSale = {};
		//state.discount = response.customPromotion.discount;
	},
	setSearchLoader(state, boolean) {
		state.searchLoading = boolean;
	},
	setPosItems(state, items) {
		state.items = items;
	},
	increaseCountWithIndex(state, dataIndex) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA IF GA KIRADI **/
		if (state.cartItems[dataIndex]._rowVariant) {
			state.cartItems[dataIndex].count -= 1;
			state.totalSum -= state.cartItems[dataIndex].priceWholesale;
		} else {
			state.cartItems[dataIndex].count += 1;
			state.totalSum += state.cartItems[dataIndex].priceWholesale;
		}
		state.lastAddedItem = null;
		state.totalCount++;

	},
	decreaseCountWithIndex(state, dataIndex) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA IF GA KIRADI **/
		if (state.cartItems[dataIndex]._rowVariant && state.cartItems[dataIndex].count < -1) {
			state.cartItems[dataIndex].count += 1;
			state.totalSum += state.cartItems[dataIndex].priceWholesale;
			state.totalCount--;
		} else if (state.cartItems[dataIndex].count > 1) {
			state.cartItems[dataIndex].count -= 1
			state.totalSum -= state.cartItems[dataIndex].priceWholesale;
			state.totalCount--;
		}
		state.lastAddedItem = null;
	},
	/** BU CODENI DRAFTNI QAYTA SET QILISHDA ISHLATSA BO'LADI **/
	/*setPosObjToState(state, posObj) {
		if (posObj) {
			state.cartItems = posObj.cartItems;
			state.totalCount = posObj.totalCount;
			state.totalSum = posObj.totalSum;
		}
	},*/
	deleteItemFromCart(state, index) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA IF GA KIRADI **/
		if (state.cartItems[index]._rowVariant) {
			state.totalCount += state.cartItems[index].count;
			state.totalSum += state.cartItems[index].priceWholesale * state.cartItems[index].count;
		} else {
			state.totalCount -= state.cartItems[index].count;
			state.totalSum -= state.cartItems[index].priceWholesale * state.cartItems[index].count;
		}
		state.cartItems.splice(index, 1);
		if (state.cartItems.length == 0) {
			state.finalTotalSum = 0;
		}
	},

	setValue(state, payload) {
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA BIRINCHI IF GA KIRADI **/
		if (state.cartItems[payload.index]._rowVariant) {
			state.totalCount += state.cartItems[payload.index].count;
			state.totalCount += payload.newCount;
			state.totalSum += state.cartItems[payload.index].count * state.cartItems[payload.index].priceWholesale;
			state.totalSum += payload.newCount * state.cartItems[payload.index].priceWholesale;
			state.cartItems[payload.index].count = -payload.newCount;
		} else {
			state.totalCount -= state.cartItems[payload.index].count;
			state.totalCount += payload.newCount;
			state.totalSum -= state.cartItems[payload.index].count * state.cartItems[payload.index].priceWholesale;
			state.totalSum += payload.newCount * state.cartItems[payload.index].priceWholesale;
			state.cartItems[payload.index].count = payload.newCount;
		}
		state.lastAddedItem = null;
	},
	setItemWeightMutation(state, payload) {
		Vue.set(state.cartItems[payload.index], "weight", payload.newWeight);
	},
	setCartItem(state, cartItem) {
		state.totalCount++;
		/** AGAR VOZVRAT QILAYOTGAN BO'LSA BIRINCHI IF GA KIRADI **/
		if (state.isReturn) {
			state.totalSum -= cartItem.priceWholesale;
			let foundIndex = (state.cartItems.findIndex(el => {
				return el.itemId == cartItem.itemId && el._rowVariant == 'danger' && el.priceWholesale == cartItem.priceWholesale;
			}));
			if (foundIndex > -1 && state.cartItems[foundIndex]._rowVariant) {
				state.lastAddedItem = null;
				state.cartItems[foundIndex].count -= 1
			} else {
				Vue.set(cartItem, "count", -1);
				Vue.set(cartItem, "_rowVariant", 'danger');
				Vue.set(cartItem, "originalPriceWholesale", cartItem.priceWholesale);
				if (cartItem.weight) {
					Vue.set(cartItem, "weight", cartItem.weight/1000);
				} else {
					Vue.set(cartItem, "weight", 0);
				}
				state.cartItems.unshift(cartItem);
				state.lastAddedItem = cartItem;
			}
		} else {
			let foundIndex = (state.cartItems.findIndex(el => {
				return el.itemId == cartItem.itemId && el.originalPriceWholesale == cartItem.priceWholesale;
			}));
			state.totalSum += cartItem.priceWholesale;
			if (foundIndex > -1 && !state.cartItems[foundIndex]._rowVariant) {
				state.lastAddedItem = null;
				state.cartItems[foundIndex].count += 1
			} else {
				Vue.set(cartItem, "count", 1);
				Vue.set(cartItem, "originalPriceWholesale", cartItem.priceWholesale);
				if (cartItem.weight) {
					Vue.set(cartItem, "weight", cartItem.weight/1000);
				} else {
					Vue.set(cartItem, "weight", 0);
				}
				state.cartItems.unshift(cartItem);
				state.lastAddedItem = cartItem;
			}
		}
	},
	/** BU VOZVRAT UCHUN **/
	setIsReturn(state, boolean) {
		state.isReturn = boolean;
	},


};

export const wholesalePos = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
